import clsx from 'clsx';
import React, { ReactNode } from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { cn } from '@/src/util/ui';

import ActionButton from '../../Elements/ActionButton/ActionButton';

const TreatmentLayout = ({
  header,
  banner,
  footer,
  children,
  containerClassName = '',
  treatmentFormHeight = '',
  isBackButtonDisabled = false,
  onBack,
}: {
  header: ReactNode;
  banner?: ReactNode;
  footer?: ReactNode;
  onBack?: () => void;
  isBackButtonDisabled?: boolean;
  treatmentFormHeight?: string;
  containerClassName?: string;
  children?: ReactNode;
}) => {
  return (
    <React.Fragment>
      <div className={cn('container--transactionForm', 'tw-p-0', containerClassName)}>
        <div
          className={clsx(
            'transactionHeader',
            'tw-sticky tw-top-0 tw-z-[1]',
            'tw-flex tw-items-center tw-justify-between',
            'tw-border-solid tw-border-b-[1px] tw-border-b-cfo-grey-500',
            'tw-pb-[15px] tw-px-[15px]',
            'tw-bg-white'
          )}
        >
          <div className={clsx('transactionTitle', 'tw-flex tw-items-center')}>
            <ActionButton
              onClick={onBack}
              disabled={isBackButtonDisabled}
              buttonType={'style_unset'}
              className={clsx(
                'tw-text-[18px]',
                'tw-p-0 tw-mr-[5px]',
                'tw-text-cfo-black',
                'disabled:tw-text-cfo-grey-400',
                'hover:enabled:tw-text-cfo-blue-700',
                'tw-peer',
                'tw-group'
              )}
            >
              <Icon
                icon={ICONS.arrow_back}
                className={clsx(
                  'tw-text-[20px]',
                  'tw-m-0',
                  'group-hover:enabled:tw-text-cfo-blue-700'
                )}
              />
              {/* {isViewMode && (
                <p
                  className={clsx(
                    'tw-text-cfo-black tw-text-[18px] tw-font-brandonTextMedium',
                    'tw-ml-[10px]',
                    'group-hover:tw-text-cfo-blue-700'
                  )}
                >
                  {title}
                </p>
              )} */}
            </ActionButton>
            {header}
            {/* <TreatmentHeader>
            {isDraft && (
                <ActionButton
                className={clsx(
                    'tw-m-0 tw-p-[2px]',
                    'tw-text-cfo-red-300 tw-bg-[#FEF0F0]',
                    'tw-rounded-[25px]',
                    'hover:tw-bg-cfo-red-400 hover:tw-text-white'
                )}
                buttonType={'style_unset'}
                onClick={onDeleteDraft}
                disabled={isFormLoading}
                >
                <Icon icon={ICONS.close} className={clsx('tw-text-[12px]')} />
                </ActionButton>
            )}
            </TreatmentHeader> */}
          </div>
        </div>

        {banner}

        <div
          className={cn(
            'treatmentBody--container',
            'tw-overflow-y-auto tw-scroll-styles',
            'tw-px-[15px] tw-pt-[15px] tw-pb-[20px]',
            treatmentFormHeight
          )}
        >
          {children}
        </div>

        {footer && (
          <div
            className={clsx(
              'treatmentFooter',
              'tw-py-[18px] tw-px-[15px]',
              'tw-border-t-[1px] tw-border-solid tw-border-cfo-grey-500'
            )}
          >
            {footer}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TreatmentLayout;
